// extracted by mini-css-extract-plugin
export default {"title":"SideMenu_title__mkwEQ","menus":"SideMenu_menus__QFVLo","secondMenu":"SideMenu_secondMenu__zzuAM"};